export default {"src":"__ASTRO_ASSET_IMAGE___d5GOYCy__","width":160,"height":172,"format":"svg"}